import { useQuery } from '@tanstack/react-query';
import { getMyAccount } from '#api/accounts';
import { fetcher } from '../libs';

export type Degree = {
  accountId: string;
  at: string;
  createdAt: string;
  diplomaNumber: string | null;
  from: string;
  id: string;
  name: string;
  status: string;
  updatedAt: string;
};

export default function useDegreesQuery() {
  return useQuery(['degrees'], async () => {
    const account = await getMyAccount();
    return fetcher<Degree[]>(`/degrees/${account.id}/all`);
  });
}
